import { RoundButton } from 'component/Button/RoundButton'
import { Loader } from 'component/Loader'
import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { useTryOn } from 'hook/useTryOn'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'
import { itemPreview, ItemPreviewStore } from 'page/catalog/store/ItemPreviewStore'
import { Item } from 'type/Item'

type Props = {
  item: Item
}

export const StandActions = observer(({ item }: Props) => {
  const demo = useDemo()
  const { item_id } = item
  const combo_selected = comboCartStore.isItemInCart(item_id)
  const try_on = demo.canTry(item)
  const mix = demo.canMix(item)
  const combine = demo.canCombine(item)

  // Используем хук с skipBoutiqueCheck для стенда
  const { loading, onTry } = useTryOn({ itemId: item_id, skipBoutiqueCheck: true })

  const onClickCombo = useLatestCallback(() => {
    comboCartStore.toggleItem(item)
  })

  const onClickTry = useLatestCallback(() => {
    if (mix) itemPreview.open(new ItemPreviewStore(item))
    else onTry()
  })

  if (!try_on && !combine) return null

  return <Vertical gap={8}>
    {!combine ? null : combo_selected ? (
      <RoundButton primary onClick={onClickCombo}>
        {i18n('InComboCart')}
      </RoundButton>) : (
      <RoundButton onClick={onClickCombo}>
        {i18n('ToComboCart')}
      </RoundButton>
    )}
    {try_on && <RoundButton fill onClick={onClickTry} disabled={loading}>
      {loading ? (
        <Space gap={8}>
          <Loader />
          {i18n('demo.TryOn')}
        </Space>
      ) : (
        i18n('demo.TryOn')
      )}
    </RoundButton>}
  </Vertical>
})
